import React from "react";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

function Location(props) {
  return !props.isGeolocationAvailable ? (
    <div>{i18n.t("locate.geolocation_not_available_tips")}</div>
  ) : !props.isGeolocationEnabled ? (
    <p> {i18n.t("locate.geolocation_not_enabled_tips")}</p>
  ) : props.coords ? (
    <div>
      <p>
        {i18n.t("locate.reported_location")}:
        <b className="location">
          <strong>{i18n.t("locate.latitude")}:</strong> {props.coords.latitude}
        </b>
        <b className="location">
          <strong>{i18n.t("locate.longitude")}:</strong>{" "}
          {props.coords.longitude}
        </b>
      </p>
      <p>{i18n.t("locate.thank_introduction")}</p>
    </div>
  ) : (
    <p>{i18n.t("locate.getting_location_data")}&hellip; </p>
  );
}

export default Location;
